import { render, staticRenderFns } from "./P02TwoDigit.vue?vue&type=template&id=dfeb186a&lang=pug"
import script from "./P02TwoDigit.vue?vue&type=script&lang=js"
export * from "./P02TwoDigit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports